module.exports = __webpack_public_path__ + "static/lights11-2c8716ab5030890d577cd50aeb3f80a9.jpg";